import React from 'react';
import Icon from '../../../components/AppIcon';

const AuditMetrics = ({ metrics }) => {
  const metricCards = [
    {
      label: 'Total Audits',
      value: metrics?.totalAudits || 0,
      icon: 'ClipboardList',
      color: 'text-blue-500',
      bgColor: 'bg-blue-500/10'
    },
    {
      label: 'Active Audits',
      value: metrics?.activeAudits || 0,
      icon: 'Activity',
      color: 'text-green-500',
      bgColor: 'bg-green-500/10'
    },
    {
      label: 'Avg. Completion Rate',
      value: `${metrics?.averageCompletionRate || 0}%`,
      icon: 'TrendingUp',
      color: 'text-purple-500',
      bgColor: 'bg-purple-500/10'
    },
    {
      label: 'Pending Responses',
      value: metrics?.pendingResponses || 0,
      icon: 'Clock',
      color: 'text-orange-500',
      bgColor: 'bg-orange-500/10'
    },
    {
      label: 'Total Participants',
      value: metrics?.totalParticipants || 0,
      icon: 'Users',
      color: 'text-indigo-500',
      bgColor: 'bg-indigo-500/10'
    },
    {
      label: 'Average Score',
      value: `${metrics?.averageScore || 0}%`,
      icon: 'Award',
      color: 'text-cyan-500',
      bgColor: 'bg-cyan-500/10'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mb-6">
      {metricCards?.map((metric, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-4 hover:shadow-md transition-shadow"
        >
          <div className="flex items-center justify-between mb-3">
            <div className={`w-10 h-10 rounded-lg ${metric?.bgColor} flex items-center justify-center`}>
              <Icon name={metric?.icon} size={20} className={metric?.color} />
            </div>
          </div>
          <div className="text-2xl font-bold text-foreground mb-1">
            {metric?.value}
          </div>
          <div className="text-xs text-muted-foreground">
            {metric?.label}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AuditMetrics;